import React from 'react'

interface BodyTwoProps {
  additionalClasses?: string
  children: React.ReactNode
  color?: string
  fontWeight?: string
  fontSize?: string
}

const BodyTwo: React.FC<BodyTwoProps> = ({
  children,
  additionalClasses = '',
  color = 'text-gray-copy',
  fontWeight = 'font-book',
  fontSize = 'text-base md:text-xl',
}) => {
  return (
    <p className={`${color} ${fontWeight} ${fontSize} ${additionalClasses}`}>
      {children}
    </p>
  )
}

export default BodyTwo
